module.exports = {
      id: "palo-bangla-usage",
      viewBox: "0 0 230 55",
      url: "/" + "svg-sprite-21c17c4d458cf2e2be6dd4c01f9ab03b.svg#palo-bangla",
      toString: function () {
        return this.url;
      }
    }